import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
import { AnyObject, Maybe } from "yup/lib/types";

declare module "yup" {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > extends yup.BaseSchema<TType, TContext, TOut> {
    phoneNumber(region?: string): StringSchema<TType, TContext>;
    areaCode(countryIso?: string): StringSchema<TType, TContext>;
    json(requiredKeys?: string[]): StringSchema<TType, TContext>;
  }
}

const phoneUtil = PhoneNumberUtil.getInstance();
yup.addMethod(
  yup.string,
  "phoneNumber",
  function (region = "US"): yup.StringSchema {
    return this.test(
      "phoneNumber",
      "Must be a valid phone number",
      function (value) {
        if (!value) {
          return true;
        }

        try {
          return (
            phoneUtil.isValidNumber(phoneUtil.parse(value, region)) ?? false
          );
        } catch (_) {
          return false;
        }
      }
    );
  }
);

yup.addMethod(
  yup.string,
  "areaCode",
  function (region = "US"): yup.StringSchema {
    return region === "AU"
      ? this.matches(/^\d{1}$/, {
          excludeEmptyString: true,
          message:
            "Enter the single digit area code (e.g. 2 for NSW or 4 for mobile phones)"
        })
      : this.matches(/^\d{3}$/, {
          excludeEmptyString: true,
          message: "Enter a three digit area code"
        });
  }
);

yup.addMethod(
  yup.string,
  "json",
  function (requiredKeys: string[] = []): yup.StringSchema {
    return this.test(
      "json",
      `Must valid a JSON string with the keys: ${requiredKeys.join(", ")}`,
      function (value) {
        if (!value) {
          return true;
        }

        try {
          const parsed = JSON.parse(value);

          if (!requiredKeys.every(k => k in parsed)) {
            return false;
          }
        } catch (_) {
          return false;
        }

        return true;
      }
    );
  }
);

export default yup;
